import { analytics, db, storage, imageStoragePath, auth, authProvider,
         adminDbPath, usersDbPath, imageDataDbPath, masterInfoDocRef } from "../firebaseConfig"
import { useEffect, useState } from "react"
import { addDoc, arrayUnion, collection, doc, documentId, getDoc, getDocs, setDoc, updateDoc } from "firebase/firestore"
import { ref, uploadBytes } from "firebase/storage"
import Papa from "papaparse"
import ProgressBar from "@ramonak/react-progress-bar"


const usersCollectionRef = collection(db, usersDbPath)
const imageDataCollectionRef = collection(db, imageDataDbPath)

export default function Admin() {
    return(<></>)
    //TODO: make this more official and find way to redirect back to show error page if not owner
    if (auth.currentUser !== null && auth.currentUser.uid !== "OUrq55KDSWTT1olbWe2Mb8WKm1J3") {
        //not csc account
    }
    
    
    return (
        <div id="admin">
            <h1>admin page</h1>

            <ImageUploader />
        </div>
    )
}


function ImageUploader() {
    const[dbImportProgress, setDbImportProgress] = useState({
        done: 0,
        outOf: 0,
        percent: 0,
        duplicates: []
    })
    const[storageImportProgress, setStorageImportProgress] = useState({
        done: 0,
        outOf: 0,
        percent: 0,
        duplicates: []
    })

    const [fileState, setFileState] = useState({
        imgDir: undefined,
        csv: undefined,
        override: false
    })
    
    
    const handleFileChange = (e) => {
        switch (e.target.name) {
            case "imageDir":
                setFileState(fileState => ({ ...fileState, imgDir: e.target.files }))
                console.log("set img dir")
                break
            case "csvFile":
                setFileState(fileState => ({ ...fileState, csv: e.target.files[0] }))
                console.log("set csv")
                break
            case "override":
                setFileState(fileState => ({ ...fileState, override: e.target.checked }))
                //TODO - why is this reversed? checked = false, unchecked = true
                console.log("set override to ", fileState.override)
                break
            default:
                console.log("file upload default case - check for errors")
                break
        }
        console.log(fileState)
    }
    
    //TODO: error handling inside upload methods thru promises on async db methods?
    const handleFileSubmit = (e) => {
        e.preventDefault()
        
        if (typeof fileState.imgDir !== 'undefined') {
            console.log(`Uploading images from the folder "${fileState.imgDir.name}" to storage` + (fileState.override ? " with override enabled" : ""))
            
            //setStorageImportProgress({ outOf: fileState.imgDir.length })

            let done = 0
            let duplicates = []
            for (let file of fileState.imgDir) {
                let result = uploadImageToStorage(file, fileState.override)

                console.log("result: ", result)
                if (result === -1) {
                    // duplicate
                    duplicates.push(file.name)
                    console.log("duplicate")
                }
                //setStorageImportProgress({ done: ++done, percent: (done / fileState.imgDir.length) })
            }

            //setStorageImportProgress({ percent: 100, duplicates: duplicates })
        }
        
        if (typeof fileState.csv !== 'undefined') {
            console.log(`Uploading csv file "${fileState.csv.name}"` + (fileState.override ? " with override enabled" : ""))
            
            Papa.parse(fileState.csv, {
                header: true,
                delimiter: ", ",
                skipEmptyLines: true,
                complete: (result) => {
                    var csvOutput = result.data
                    // TODO - HOW TO FIX WHERE SETTING INDIVIDUAL STATE PROPERTIES CHANGES THE REST TO UNDEFINED??
                    //setImportProgress({ outOf: csvOutput.length })

                    console.log("CSV output data:", csvOutput)
                    console.log(`Starting to upload the data of ${csvOutput.length} images to the database`)
                    uploadImageDataToDB(csvOutput, fileState.override, dbImportProgress, setDbImportProgress)
                }
            })
        }
    }
    


    return (
        <div style={{ textAlign: "center" }}>

            <h3>Import new images and image data into database</h3>
            <form>
                <label>
                    Images inside a folder (CHROME ONLY!):
                    <input
                        type="file"
                        name="imageDir"
                        webkitdirectory=""
                        directory=""
                        onChange={handleFileChange}
                        />
                </label>
                
                <label>
                    Image data as .csv:
                    <input
                        type="file"
                        name="csvFile"
                        accept=".csv"
                        onChange={handleFileChange}
                        />
                </label>

                <label>
                    Override existing:
                    <input
                        name="override"
                        type="checkbox"
                        onChange={handleFileChange}
                        />
                </label>

                <button
                    onClick={(e) => {
                        handleFileSubmit(e)
                    }}
                    >
                    Import Into Database
                </button>
            </form>

            <h2>{"db: " + dbImportProgress.done + dbImportProgress.outOf + dbImportProgress.percent + dbImportProgress.duplicates}</h2>
            <div id="dbImportProgress" hidden={dbImportProgress.outOf <= 0 || dbImportProgress.percent >= 100}>
                <ProgressBar
                    completed={dbImportProgress.percent}
                    bgColor="#008000"
                    width="80%"
                    margin="10px"
                    />
                <p>{ `Image Data Uploaded: ${dbImportProgress.done} / ${dbImportProgress.outOf}` }</p>
            </div>
            <div id="dbImportResults">
                <p id="uploadSuccess" hidden>{ `Successfully uploaded the data for ${dbImportProgress.done} images!` }</p>
                <p id="uploadDuplicate" hidden>{ `Did not upload the data for ${dbImportProgress.duplicates.length} images because they already exist in the database!` }</p>
                <p id="uploadDuplicateList" hidden>{ `Duplicates image IDs:  ${toString(dbImportProgress.duplicates)}` }</p>
            </div>

            <h2>{"storage: " + storageImportProgress.done + storageImportProgress.outOf + storageImportProgress.percent + storageImportProgress.duplicates}</h2>
            <div id="storageImportProgress" hidden={storageImportProgress.outOf <= 0 || storageImportProgress.percent >= 100}>
                <ProgressBar
                    completed={storageImportProgress.percent}
                    bgColor="#008000"
                    width="80%"
                    margin="10px"
                    />
                <p>{ `Images Uploaded: ${storageImportProgress.done} / ${storageImportProgress.outOf}` }</p>
            </div>
            <div id="storageImportResults">
                <p id="uploadSuccess" hidden>{ `Successfully uploaded ${storageImportProgress.done} images!` }</p>
                <p id="uploadDuplicate" hidden>{ `Did not upload ${storageImportProgress.duplicates.length} images because they already exist in the storage!` }</p>
                <p id="uploadDuplicateList" hidden>{ `Duplicates images:  ${toString(storageImportProgress.duplicates)}` }</p>
            </div>

        </div>
    )
}


// input a file with the ID as its name and upload it to a folder in the cloud storage
// returns -1 if duplicate, otherwise success
async function uploadImageToStorage(file, override) {
    const masterInfoDoc = await getDoc(masterInfoDocRef)
    const masterImageList = masterInfoDoc.data().imageList;

    const id = file.name.substring(0, file.name.indexOf('.'))
    
    console.log(`override: ${override}   contains: ${masterImageList.includes(id)}`)
    if (!override && masterImageList.includes(id)) {
        console.log("duplicate")
        return -1 // duplicate
    }
    
    await uploadBytes(ref(storage, imageStoragePath + file.name), file).then(() => {
        console.log("uploaded ", file.name)
    })
}



// input an array of csv image info and put it all into firestore based on ID, and optionally override existing database entries
async function uploadImageDataToDB(dataArr, override, importProgress, setImportProgress) {
    const masterInfoDoc = await getDoc(masterInfoDocRef)
    const masterImageList = masterInfoDoc.data().imageList;
    
    let done = 0
    let duplicates = []
    
    for (let data of dataArr) {
        // TODO - WHY DOES THIS DUPLICATE CHECKING NOT WORK? - print values before checking
        if (!override && masterImageList.includes(data.ID)) {
            duplicates.push(data.ID)
        } else {
            await setDoc(doc(db, imageDataDbPath, data.ID), { owner: "system", ownerHistory: [], properties: data })
            updateDoc(masterInfoDocRef, { imageList: arrayUnion(data.ID) })
        }

        //setImportProgress({ done: ++done, percent: (done / dataArr.length) })
    }
    
    console.info("done   ", importProgress)
    //setImportProgress({ percent: 100, duplicates: duplicates })
    document.getElementById("uploadSuccess").hidden = false
    document.getElementById("uploadDuplicate").hidden = duplicates.length <= 0
    document.getElementById("uploadDuplicateList").hidden = duplicates.length <= 0
}